import React, { useState, useEffect } from 'react';
import { CardComponentProps } from '@/lib/cards';

/**
 * User Information Card
 * Displays detailed user information
 */
export const UserInfoCard: React.FC<CardComponentProps> = ({
  card,
  userContext,
  onError,
}) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        setLoading(true);
        const mockData = {
          name: 'John Doe',
          email: 'john.doe@example.com',
          userId: 'user-123',
          organisationId: 'org-456',
          joinedDate: '2024-01-15',
          lastActive: '2026-03-18T10:30:00Z',
        };
        setData(mockData);
      } catch (err) {
        onError?.(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, [onError]);

  if (loading) {
    return <div style={{ padding: '1rem', color: '#666' }}>Loading user information...</div>;
  }

  if (!data) return null;

  return (
    <div style={{ padding: '1rem' }}>
      <div style={{ display: 'grid', gap: '0.75rem' }}>
        <div>
          <strong>Name:</strong> {data.name}
        </div>
        <div>
          <strong>Email:</strong> {data.email}
        </div>
        <div>
          <strong>User ID:</strong> <code style={{ backgroundColor: '#f5f5f5', padding: '0.25rem 0.5rem' }}>{data.userId}</code>
        </div>
        <div>
          <strong>Organisation:</strong> {data.organisationId}
        </div>
        <div>
          <strong>Joined:</strong> {new Date(data.joinedDate).toLocaleDateString()}
        </div>
        <div>
          <strong>Last Active:</strong> {new Date(data.lastActive).toLocaleString()}
        </div>
      </div>
    </div>
  );
};

UserInfoCard.displayName = 'UserInfoCard';

export default UserInfoCard;
